/* oxlint-disable react/static-components -- these render APIs intentionally receive component references */
import { AIBadgePill } from 'app/components/Icon/AIBadgeIcon'
import { chipBase, hueClasses, tagChipClasses } from 'app/lib/chipColors'
import { cn } from 'app/lib/utils'
import { getBuiltInTagIcon } from 'lib/builtInTagIcons'

type TagChipProps = {
  name: string
  /** Stored TagColor key (`bg-tags-*`); used as a palette lookup, never applied as a class. */
  colorKey?: string | null
  className?: string
  labelClassName?: string
  onRemove?: () => void
}

/** Pure presentational tag chip. Data-aware callers go through Tag.tsx, which
 *  resolves the color key; this renders anywhere (pickers, previews, cells). */
export function TagChip({ name, colorKey, className, labelClassName, onRemove }: TagChipProps) {
  // The AI tag renders as the same "✦ AI" pill the inbox conversation list uses.
  if (name.toUpperCase() === `AI`) {
    return <AIBadgePill className={cn(`h-5 w-auto shrink-0 align-middle`, className)} />
  }
  const Icon = getBuiltInTagIcon(name)
  // Emergency always wears the warning recipe: its color key resolves to silver
  // in contexts that lack a TagColor row (e.g. the contacts model).
  const colorClasses = name === `Emergency` ? hueClasses.warning : tagChipClasses(colorKey)
  return (
    <span x-component-name="TagChip" className={cn(chipBase, colorClasses, className)}>
      {Icon && <Icon className="h-3 w-3 shrink-0" />}
      <span className={labelClassName}>{name}</span>
      {onRemove && (
        <button type="button" onClick={onRemove} className="shrink-0 opacity-60 transition-opacity hover:opacity-100">
          <svg className="h-2 w-2" stroke="currentColor" fill="none" viewBox="0 0 8 8">
            <path strokeLinecap="round" strokeWidth="1.5" d="M1 1l6 6m0-6L1 7" />
          </svg>
        </button>
      )}
    </span>
  )
}
